import { useDispatch, useSelector } from "react-redux";
import userProfileSelectors from "redux/UserProfile/selectors";
import MyAlert from "./MyAlert";
import { useEffect, useState } from "react";
import navOperations from "../../../../../redux/Navigation/operations"
import { AlertNotificationDispatch as myAlertDispatch } from "Store/AlertNotification/AlertNotificationDispatch";
import { SetDeleteAlertNotificationdetails, SetDeleteAllAlerts } from "Store/AlertNotification/AlertNotificationAction";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { CONSTANTS } from "client/utils/constants";
import { useNavigate } from "react-router-dom";
import permissions, { isAuthorized } from "client/utils/Permissions";
import TransferAction from "Store/Component/Transfer/TransferAction";

const MyAlertContainer = (props: any) => {
  let dispatch = useDispatch();
  const navigate = useNavigate();

  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteAllAlerts, setDeleteAllAlert] = useState(false);  
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);  
  const dispatchGetMyAlertDetails = myAlertDispatch.dispatchGetMyAlertNotificationDetails(dispatch);
  const dispatchGetDeleteAlertNotificationdetails = myAlertDispatch.dispatchGetDeleteAlertNotificationdetails(dispatch);
  const dispatchGetDeleteAllAlerts = myAlertDispatch.dispatchSetDeleteAllAlerts(dispatch);  

  const { myAlertDetails, userDetails, deleteNotificationflag, deleteAllAlertsFlag, isAlertNotificationApiCalled }: any = useSelector((state: any) => (
    {
      myAlertDetails: state.AlertAndNotificationsReducer.myAlertNotificationDetails,
      isAlertNotificationApiCalled: state.AlertAndNotificationsReducer.isAlertNotificationApiCalled,
      userDetails: userProfileSelectors.getUserDetails(state),
      deleteNotificationflag: state.AlertAndNotificationsReducer.DeleteAlertNotificationDetails,
      deleteAllAlertsFlag: state.AlertAndNotificationsReducer.deleteAllAlerts
    }));

  const onDeleteConfirm = async () => {
    const deleteNotification = { "notificationId": deletePopup, "userId": userDetails?.userId };
    dispatchGetDeleteAlertNotificationdetails(deleteNotification);
    setDeletePopup(false);
  };
  useEffect(() => {
    if (deleteNotificationflag || deleteAllAlertsFlag) {
      dispatchGetMyAlertDetails(userDetails?.userId);
      dispatch(SetDeleteAlertNotificationdetails(false));
      dispatch(SetDeleteAllAlerts(false));
    }
  }, [deleteNotificationflag, deleteAllAlertsFlag])

  const onOrderClick = (orderId: any, navigateTo: any, item: any, isBulkOrder: boolean) => {
    dispatch(RequisitionAction.setIsChangesOccured(false))
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
    if (navigateTo && orderId) {
      if (navigateTo == "PendingApprovalOrders") {
        if (item?.includes(CONSTANTS.TRANSFER) || item?.includes(CONSTANTS.DISPOSITION) || item?.includes(CONSTANTS.REACTIVATION)) {
          dispatchHeaderNav("Home");
          navigate('/ordermanagement/assetorderapproval/' + orderId);
        } else if(isBulkOrder){
          dispatchHeaderNav("Home");
          navigate('/ordermanagement/bulkorderapproval/' + orderId);  
        }else if(item?.includes(CONSTANTS.AFEREQUEST)) {
          dispatchHeaderNav("Home");
          navigate('/ordermanagement/afeorderapproval/' + orderId + '/' + CONSTANTS.AFEREQUEST);
        }
        else {
          dispatchHeaderNav("Home");
          navigate('/ordermanagement/requisitionorderapproval/' + orderId);
        }
      }else if(navigateTo == "FleetProcessing" && isAuthorized(permissions.CreateUpdatePurchaseOrders)){
        if (item?.includes(CONSTANTS.TRANSFER) || item?.includes(CONSTANTS.DISPOSITION) || item?.includes(CONSTANTS.REACTIVATION)) {
          dispatchHeaderNav("Home");
          navigate('/ordermanagement/fleetprocessingasset/' + orderId + '/home');
        } else if(isBulkOrder){
          dispatchHeaderNav("Home");
          navigate('/ordermanagement/fleetprocessingbulkorderdetail/' + orderId + '/home');  
        }else if(item?.includes(CONSTANTS.AFEREQUEST)) {
          dispatchHeaderNav("Home");
          navigate('/ordermanagement/fleetprocessingasset/' + orderId + '/home' + '/' + CONSTANTS.AFEREQUEST);
        } else {
          dispatchHeaderNav("Home");
          navigate('/ordermanagement/fleetprocessingorderdetail/' + orderId + '/home');
        }
      }else {
        if (item?.includes(CONSTANTS.TRANSFER) || item?.includes(CONSTANTS.DISPOSITION) || item?.includes(CONSTANTS.REACTIVATION)) {
          navigate('/ordermanagement/assetorderdetail/' + orderId + '/home');
        } else if(isBulkOrder){
          navigate('/ordermanagement/bulkorderdetail/' + orderId + '/home');  
        } else if(item?.includes(CONSTANTS.AFEREQUEST)){
            navigate('/ordermanagement/afeorderdetail/' + orderId + '/home' + '/' + CONSTANTS.AFEREQUEST);
          }else {
          navigate('/ordermanagement/requisitionorderdetail/' + orderId + '/home');
        }
      }

    }else{
      return
    }    
   
  };

  useEffect(() => {
    myAlertDetails?.alertDetails?.forEach((value: any, index: any) => {
      const linkTag = document?.querySelector(`.click-alert-${index}`)?.querySelectorAll('a') ?? [];
      if (linkTag?.length != 0) {
        const orderId = linkTag[0]?.getAttribute("data-orderid");
        const navigationPath = linkTag[0]?.getAttribute("data-navigationpath");

        let divContainer = document.createElement("div");
        divContainer.innerHTML = value?.notificationMessage;
        let text = (divContainer?.childNodes[0]?.childNodes[2]?.textContent);
        let isBulkOrder = (divContainer?.childNodes[0]?.childNodes[0]?.childNodes[1]?.textContent) === CONSTANTS?.BULK_ORDER;
        linkTag[0]?.removeEventListener("click", () => { });
        linkTag[0]?.addEventListener("click", (e: any) => {
          e.preventDefault();
          onOrderClick(orderId, navigationPath, text, isBulkOrder);
        });

        if (linkTag?.length == 2) {
          linkTag[1]?.removeEventListener("click", () => { });
          linkTag[1]?.addEventListener("click", (e: any) => {
            e.preventDefault();
            onOrderClick(orderId, navigationPath, text, isBulkOrder);
          });
        }
      }
    });
  }, [myAlertDetails?.alertDetails]);

  const clearAllAlert = (e: any) => {
    e.preventDefault()
    setDeleteAllAlert(true)
  }

  const onDeleteAllConfirmation = () => {
    dispatchGetDeleteAllAlerts(userDetails?.emailId)
    setDeleteAllAlert(false)
  }

  return (
    <MyAlert
      myAlertDetails={myAlertDetails}
      onDeleteConfirm={onDeleteConfirm}
      deletePopup={deletePopup}
      setDeletePopup={setDeletePopup}
      clearAllAlert={clearAllAlert}
      deleteAllAlerts={deleteAllAlerts}
      setDeleteAllAlert={setDeleteAllAlert}
      onDeleteAllConfirmation={onDeleteAllConfirmation}
      isLoading={isAlertNotificationApiCalled}
    />
  );
};

export default MyAlertContainer;
